// This file was generated using `pay js:run gql-v1 --type=mutation --name=RequireExternalAccountVerification --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';
import {useV1Mutation} from '@stripe-internal/data-v1';

import type {GraphQlDocument, ApolloError} from '@sail/data';

import type {
  V1MutationOptions,
  V1MutationOptionsWithoutVariables,
  V1MutationReturn,
  V1PermissionToken,
} from '@stripe-internal/data-v1/types';

import type {
  Exact,
  InputMaybe,
  OpenapiPostV1ConnectAuthRequiresExternalAccountVerificationInput,
  V1ContextInput,
  OpenapiConnectAuthResourcesRequiresExternalAccountVerificationObjectFieldType,
} from '@stripe-internal/data-v1/schema/types';

const doc = gql`
  mutation RequireExternalAccountVerificationMutation(
    $input: OpenapiPostV1ConnectAuthRequiresExternalAccountVerificationInput
    $v1Context: V1ContextInput!
  ) {
    v1ConnectAuthRequiresExternalAccountVerification(
      input: $input
      v1Context: $v1Context
    ) {
      challenge
      key
      object
      requires_verification
      identity_auth_eligible
      account_number_verification_eligible
    }
  }
`;

export const requireExternalAccountVerificationMutation: RequireExternalAccountVerificationMutationDocument =
  doc;

// Fill these options as needed. Options are documented at
// http://go/sail/apis/data/graphql-usage/the-basics-runtime#operation-options
const requireExternalAccountVerificationMutationOptions: V1MutationOptionsWithoutVariables<RequireExternalAccountVerificationMutationDocument> =
  {
    // expectedErrors: [],
    // mutedErrors: [],
    // fetchPolicy: 'cache-first',
    // ...

    // TODO: This is a legacy behavior that was present in the original Apollo
    // wrappers and is not standard. If you are not using this error for anything
    // feel free to remove it (More info: go/throw-errors-on-mutations)
    onError(error: ApolloError) {
      throw error;
    },
  };

export default function useRequireExternalAccountVerificationMutation(
  options: V1MutationOptions<RequireExternalAccountVerificationMutationDocument> = {},
): V1MutationReturn<RequireExternalAccountVerificationMutationDocument> {
  return useV1Mutation(
    requireExternalAccountVerificationMutation,
    Object.assign(
      {},
      requireExternalAccountVerificationMutationOptions,
      options,
    ),
  );
}

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type RequireExternalAccountVerificationMutationVariables = Exact<{
  input?: InputMaybe<OpenapiPostV1ConnectAuthRequiresExternalAccountVerificationInput>;
  v1Context: V1ContextInput;
}>;

export type RequireExternalAccountVerificationMutationData = {
  readonly __typename: 'Mutation';
  readonly v1ConnectAuthRequiresExternalAccountVerification: {
    readonly __typename: 'OpenapiConnectAuthResourcesRequiresExternalAccountVerification';
    readonly challenge: string | null;
    readonly key: string | null;
    readonly object: OpenapiConnectAuthResourcesRequiresExternalAccountVerificationObjectFieldType;
    readonly requires_verification: boolean;
    readonly identity_auth_eligible: boolean | null;
    readonly account_number_verification_eligible: boolean | null;
  } | null;
};

const requireExternalAccountVerificationMutationPermissions = {} as const;

doc.permissions = requireExternalAccountVerificationMutationPermissions;

export type RequireExternalAccountVerificationMutationPermissions =
  V1PermissionToken<
    typeof requireExternalAccountVerificationMutationPermissions
  >;

export type RequireExternalAccountVerificationMutationDocument =
  GraphQlDocument<
    RequireExternalAccountVerificationMutationData,
    RequireExternalAccountVerificationMutationVariables,
    RequireExternalAccountVerificationMutationPermissions
  >;
